import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createSvgIcon } from '@mui/material/utils';
// From Material Design Icons: https://pictogrammers.com/library/mdi/
// MDI Icon Name: 'arrow-top-left-thick'
export const ArrowTopLeftThickIcon = createSvgIcon(_jsx("path", { fill: 'currentColor', d: 'M9.12,11.94V16.89H5.69V5.69H16.89V9.12H11.94L18.31,15.5L15.5,18.31L9.12,11.94Z' }), 'ArrowTopLeftThick');
